import {LoginComponent} from "./login.component";
import {LogoutComponent} from "../logout/logout.component";


export const LoginRoutes = [
    {path: 'login', component: LoginComponent},
    {path: 'logout', component: LogoutComponent},

]


// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/login/login.routes.ts